import BaseModel from '../base/BaseModel.model';
export default class ProjectType extends BaseModel {

   public id: number = 0;
   public name: string ="";

    init(){
        this.id = 0;
       this.name = "";
    }

}